import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import smComponentVue from '@/views/sm/sm.vue';
import saComponentVue from '@/views/sa/sa.vue';
import sicComponentVue from '@/views/sic/sic.vue';
import memberComponentVue from '@/views/member/member.vue';

// 無分角色
import LoginRouter from './login';
import ErrorsRouter from './errors';

// 區經理
import sicEventActivityRouter from './sic/event-activity';

// 店長
import smChatRoomRouter from './sm/chat-room';
import smItemsListRouter from './sm/items-list';
import smLabelRouter from './sm/label';
import smMsgManagerRouter from './sm/msg-manager';
import smReservationRouter from './sm/reservation';
import smStoreManagerRouter from './sm/stores-manager';
import smContactsRouter from './sm/contacts';
import smMyCustomerRouter from './sm/my-customer';
import smProfileRouter from './sm/profile';
import smQRCodeRouter from './sm/qr-code';
import smInvitationsRouter from './sm/invitation';
import smEventActivityRouter from './sm/event-activity';
import smGroupPushRouter from './sm/group-push';

// 顧問
import saSignUpRouter from './sa/sign-up';
import saChatRoomRouter from './sa/chat-room';
import saQRCodeRouter from './sa/qr-code';
import saItemsListRouter from './sa/items-list';
import saProfileRouter from './sa/profile';
import saLabelRouter from './sa/label';
import saMsgManagerRouter from './sa/msg-manager';
import saReservationRouter from './sa/reservation';
import saContactsRouter from './sa/contacts';
import saMyCustomerRouter from './sa/my-customer';
import saGroupPushRouter from './sa/group-push';
import saInvitationsRouter from './sa/invitation';
import saEventActivityRouter from './sa/event-activity';

// 顧客
import memberSignUpRouter from './member/sign-up';
import memberChangeSaRouter from './member/change-sa';
import memberMySaRouter from './member/my-sa';
import memberBindSaRouter from './member/bind-sa';
import memberReservationRouter from './member/reservation';
import memberInvitationsRouter from './member/invitation';
import memberEventActivityRouter from './member/event-activity';
import memberCardRouter from './member/card';


Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    name: 'Home',
    beforeEnter: (to, from, next) => {
      const token = sessionStorage.getItem('token');

      if (token) {
        // sessionStorage 有 token 直接轉導至目的頁
        if (to.name === undefined || to.name === 'Home') {
          next('/error/404');
        } else {
          next();
        }
      } else {
        // 沒有 token 轉至 line login 取 token
        const responseType = 'code';
        const lineMessageChannelId = process.env.VUE_APP_LINE_MESSAGE_CHANNEL_ID;
        const lineLoginChannelId = process.env.VUE_APP_LINE_LOGIN_CHANNEL_ID;
        const redirectUri = encodeURIComponent(process.env.VUE_APP_LINE_LOGIN_REDIRECT_URL); // LINE Login 轉導至的後端 url
        // 後端轉導回前端的過渡頁 url
        const base_url = process.env.VUE_APP_BASE_PATH !== '/' ? process.env.VUE_APP_BASE_PATH : '';
        const middleUrl = encodeURIComponent(`${window.location.protocol}//${window.location.host}${base_url}/login/index`);
        const scope = 'openid profile email';
        // 取得網址原本的 query (如果有的話)
        const queryString = window.location.href.split('?')[1];
        let state = `channel_id=${lineMessageChannelId}|login_channel_id=${lineLoginChannelId}|middle_url=${middleUrl}|final_route_name=${to.name}`;
        if (queryString !== undefined) state += `|query_string=${queryString}`;
        state = encodeURIComponent(state);
        const lineLoginUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=${responseType}&client_id=${lineLoginChannelId}&redirect_uri=${redirectUri}&scope=${scope}&bot_prompt=aggressive&state=${state}`;
        // 轉址
        window.location = lineLoginUrl;
      }
    },
    component: Home,
    children: [
      // 區經理
      {
        path: '/sic/*',
        component: sicComponentVue,
        meta: { requiresAuth: true },
        children: [
          sicEventActivityRouter
        ]
      },
      // 店長
      {
        path: '/sm/*',
        component: smComponentVue,
        meta: { requiresAuth: true },
        children: [
          smChatRoomRouter,
          smItemsListRouter,
          smLabelRouter,
          smMsgManagerRouter,
          smReservationRouter,
          smStoreManagerRouter,
          smContactsRouter,
          smMyCustomerRouter,
          smQRCodeRouter,
          smProfileRouter,
          smInvitationsRouter,
          smEventActivityRouter,
          smGroupPushRouter
        ]
      },
      // 顧問
      saSignUpRouter,
      {
        path: '/sa/*',
        component: saComponentVue,
        meta: { requiresAuth: true },
        children: [
          saChatRoomRouter,
          saQRCodeRouter,
          saItemsListRouter,
          saProfileRouter,
          saLabelRouter,
          saMsgManagerRouter,
          saReservationRouter,
          saContactsRouter,
          saMyCustomerRouter,
          saGroupPushRouter,
          saInvitationsRouter,
          saEventActivityRouter
        ]
      },
      // 顧客
      memberSignUpRouter,
      memberBindSaRouter,
      {
        path: '/member/*',
        component: memberComponentVue,
        meta: { requiresAuth: true },
        children: [
          memberChangeSaRouter,
          memberMySaRouter,
          memberReservationRouter,
          memberInvitationsRouter,
          memberEventActivityRouter,
          memberCardRouter
        ]
      }
    ]
  },
  // For Line Login
  LoginRouter,
  // 錯誤頁面
  ErrorsRouter
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
